import React from 'react';
import PropTypes from 'prop-types'
import {Paper, CircularProgress} from 'material-ui';
import styles from './Loading.css';
import {blue600} from 'material-ui/styles/colors';

class Loading extends React.Component {

    render() {
        let content;
        let progress = (
            <CircularProgress color={blue600} size={70} thickness={5} style={styles.progress}/>
        );

        if (this.props.overlay) {
            content = (
                <div style={styles.overlay}>
                    {progress}
                </div>
            );
        } else if (this.props.paper) {
            content = (
                <Paper style={styles.content}>
                    {progress}
                </Paper>);
        } else {
            content = (
                <div style={styles.content}>
                    {progress}
                </div>);
        }

        return content;
    }
}

Loading.defaultProps = {
    paper: true,
    overlay: false
};

Loading.propTypes = {
    paper: PropTypes.bool,
    overlay: PropTypes.bool
};

export default Loading;



// WEBPACK FOOTER //
// src/components/common/Loading/Loading.js